import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default class DragIndicator extends React.Component {
    render() {
        return (
            <div className="drag-indicator float-left">
                <FontAwesomeIcon icon={faEllipsisV} />
                <FontAwesomeIcon icon={faEllipsisV} />
            </div>
        );
    }
}
